export class ListOfStatesResponse {
	id: string;
	name: string;
}
